var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            title: "编辑悬浮窗",
            width: "950px",
            top: "5vh",
            "custom-class": "dialog_box",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "from_box" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "130px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "左侧图标:", prop: "image" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "130px",
                            height: "130px",
                            background: "#f9f9f9",
                            "border-radius": "4px",
                            border: "1px solid #eeeeee",
                            position: "relative",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                "show-file-list": false,
                                action: "",
                                "http-request": _vm.handleFileUpload,
                              },
                            },
                            [
                              _vm.ruleForm.floatingWindowPic
                                ? _c("el-image", {
                                    staticStyle: {
                                      width: "130px",
                                      height: "130px",
                                    },
                                    attrs: {
                                      src: _vm.ruleForm.floatingWindowPic,
                                      fit: "contain",
                                    },
                                  })
                                : _c("i", {
                                    staticClass:
                                      "el-icon-plus avatar-uploader-icon",
                                  }),
                              _vm._v(" "),
                              _vm.ruleForm.floatingWindowPic
                                ? _c("i", {
                                    staticClass: "el-icon-error",
                                    staticStyle: {
                                      position: "absolute",
                                      right: "-30px",
                                      top: "-10px",
                                      "font-size": "25px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.delPic($event)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#969696",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v("建议图片尺寸70*70")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "活动跳转:", prop: "jumpType" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.jumpType,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "jumpType", $$v)
                            },
                            expression: "ruleForm.jumpType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("选择活动"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("url跳转"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.ruleForm.jumpType === 2
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "活动选择:" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.goAct()
                                },
                              },
                            },
                            [_vm._v("去选择")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ruleForm.jumpType === 2
                    ? _c("el-form-item", { attrs: { label: "" } }, [
                        _vm.ruleForm.activityName &&
                        _vm.ruleForm.activityTypeName
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "background-color": "#f8f8f8",
                                  padding: "10px",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "flex-start",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { width: "80px" } },
                                      [_vm._v("活动类型:")]
                                    ),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: { readonly: true },
                                      model: {
                                        value: _vm.ruleForm.activityTypeName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "activityTypeName",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.activityTypeName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "flex-start",
                                      "align-items": "center",
                                      margin: "5px 0",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { width: "80px" } },
                                      [_vm._v("活动名称:")]
                                    ),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: { readonly: true },
                                      model: {
                                        value: _vm.ruleForm.activityName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "activityName",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.activityName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ruleForm.jumpType === 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "跳转链接:", prop: "openUrl" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入跳转链接" },
                            model: {
                              value: _vm.ruleForm.openUrl,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "openUrl", $$v)
                              },
                              expression: "ruleForm.openUrl",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("确认")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.resetForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("ActivitySelectionPopup", {
        ref: "activitySelectionPopup",
        on: { SelectEvents: _vm.onSelectEvents },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }